import { Button, Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  const { t } = useTranslation();

  console.error(error);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          gap: 3,
        }}
      >
        <Typography variant="h1" sx={{ fontSize: "3rem", fontWeight: "bold" }}>
          {t("error.title")}
        </Typography>

        <Typography variant="h5" color="text.secondary">
          {t("error.description")}
        </Typography>

        {isRouteErrorResponse(error) ? (
          <>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              {error.status}: {error.statusText}
            </Typography>

            {error.data && (
              <Typography variant="body1" color="text.secondary">
                {error.data}
              </Typography>
            )}
          </>
        ) : (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontStyle: "italic" }}
          >
            {error.statusText || error.message}
          </Typography>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={handleReload}
          size="large"
        >
          {t("error.reload")}
        </Button>
      </Box>
    </Container>
  );
}
